import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function setAffiliateCookie(code: string) {
  const expires = new Date();
  expires.setDate(expires.getDate() + 30); // 30 days
  document.cookie = `affiliate_code=${encodeURIComponent(code)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  console.log('[Affiliate] Cookie set for code:', code, 'expires:', expires.toUTCString());
}

export function useAffiliateTracking() {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const refCode = searchParams.get('ref');
    if (refCode) {
      console.log('[Affiliate] Detected ref parameter:', refCode);
      setAffiliateCookie(refCode);
    }
  }, [searchParams]);
}
